import { createApp } from 'vue'
import App from '@/App.vue'
import router from "@/router"
import store from "@/store"
import ConfirmationService from 'primevue/confirmationservice'
import setupInterceptors from '@/services/setupInterceptors'
import PrimeVue from 'primevue/config'
import "primevue/resources/themes/lara-light-amber/theme.css"
import VueClick from 'vue-click'
import { installEventBus } from '@/plugins/event-bus'
import VueTailwindDatepicker from 'vue-tailwind-datepicker'
import "@/assets/css/style.css"
import "@/assets/css/primevue.css"
import moshaToast from 'mosha-vue-toastify'
import 'mosha-vue-toastify/dist/style.css'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)
  .use(router)
  .use(store)
  .use(pinia)
  .use(ConfirmationService)
  .use(installEventBus)
  .use(VueTailwindDatepicker)
  .use(PrimeVue, {
    locale: {
        emptyFilterMessage: 'Aucun résultat trouvé',
        fileSizeTypes: ['2Mo', '2Mo', '2Mo']
    },
  })
  .use(VueClick)
  .use(moshaToast)
  .mount('#app');

setupInterceptors()
